import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";
import TryItButton from "../../../TryItButton";
import OutputBox from "../../../OutputBox";

export default function JS_Loops_for() {
  return (
    <div className="tutorial-container read-only">
      <h1 className="tutorial-title">🔁 JavaScript for Loop</h1>

      {/* Explanation */}
      <div className="tutorial-section">
        <h2 className="section-title">💡 What is a for loop?</h2>
        <p>
          The <code className="highlight_code ">for</code> loop executes a block
          of code a known number of times. It's ideal when you know how many
          iterations you need.
        </p>
        <div
          style={{
            background: "linear-gradient(135deg, #fef3c7, #fde68a)",
            padding: "1rem",
            borderRadius: "12px",
            marginTop: "2rem",
            paddingLeft: "35px",
          }}
        >
          <h3 style={{ color: "#92400e" }}>🛠 How it works:</h3>
          <ol className="tutorial-list-points">
            <li>
              <b>Initialization:</b> Set a starting variable, e.g.,{" "}
              <code className="highlight_code ">let i = 0;</code>
            </li>
            <li>
              <b>Condition:</b> The loop continues{" "}
              <b>while the condition is true</b>, e.g.,{" "}
              <code className="highlight_code ">i &lt; 5</code>
            </li>
            <li>
              <b>Code Block:</b> The statements inside{" "}
              <code className="highlight_code ">{`{ ... }`}</code> are executed
              each iteration.
            </li>
            <li>
              <b>Increment/Update:</b> Modify the loop variable after each
              iteration, e.g., <code className="highlight_code ">i++</code>.
            </li>
          </ol>
        </div>
      </div>

      {/* Example 1 */}
      <div className="tutorial-section">
        <h2 className="section-title">1️⃣ Counting Numbers</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`for (let i = 1; i <= 5; i++) {
  console.log("Count:", i);
}`}
          />
          <TryItButton
            code={`for (let i = 1; i <= 5; i++) {
  console.log("Count:", i);
}`}
          />
        </div>
        <OutputBox>
          <pre>
            Count: 1{"\n"}
            Count: 2{"\n"}
            Count: 3{"\n"}
            Count: 4{"\n"}
            Count: 5
          </pre>
        </OutputBox>
      </div>

      {/* Example 2 */}
      <div className="tutorial-section">
        <h2 className="section-title">2️⃣ Iterating an Array</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let courses = ["JavaScript", "React", "Node"];
for (let i = 0; i < courses.length; i++) {
  console.log("Course:", courses[i]);
}`}
          />
          <TryItButton
            code={`let courses = ["JavaScript", "React", "Node"];
for (let i = 0; i < courses.length; i++) {
  console.log("Course:", courses[i]);
}`}
          />
        </div>
        <OutputBox>
          <pre>
            Course: JavaScript{"\n"}
            Course: React{"\n"}
            Course: Node
          </pre>
        </OutputBox>
      </div>

      {/* Next Steps */}
      <div
        style={{
          background: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2 style={{ color: "#1e40af" }}>🚀 Next Steps</h2>
        <ul className="tutorial-list-points">
          <li>
            Compare <code className="highlight_code ">for</code> loops with{" "}
            <code className="highlight_code ">while</code> loops.
          </li>
          <li>
            Experiment with nested <code className="highlight_code ">for</code>{" "}
            loops.
          </li>
          <li>
            Practice using <code className="highlight_code ">break</code> and{" "}
            <code className="highlight_code ">continue</code> inside loops.
          </li>
        </ul>
      </div>
    </div>
  );
}
